<template>
      <div class="relative">
        <slot />
        <!--  <pencil class="m-1 border border-solid border-gray-600 text-black absolute top-0 right-0 bg-gray-200" />-->
      </div>
</template>
<script>
//import Pencil from '@icons/Pencil.vue';
import TooltipEdit from '@icons/TooltipEdit.vue';
export default {
  components: {
    //Pencil,
    //TooltipEdit
  }
}
</script>
